module.exports = __webpack_public_path__ + "img/cryptoz_card_platinum.205ef7d0.svg";